import importerSelectors from '../../../modules/shared/importer/importerSelectors'

const addressImporterSelectors = importerSelectors(
  'address.importer',
)

export default addressImporterSelectors
